const mutationFn = (qraftOptions, schema, args)=>{
    const [client, options] = args;
    return client(schema, {
        parameters: options?.parameters,
        body: options?.body
    });
};

export { mutationFn };
//# sourceMappingURL=mutationFn.js.map
